import React, { memo, useMemo } from 'react';
import { createUseStyles, Text } from '@Sage/hoi-poi-ui';
import Image from './components/Image';

import styles from './styles.js';

const useStyles = createUseStyles(styles, 'Generic error');

const Error = ({ logo, title, description, image: ImageProp }) => {
    const classes = useStyles();

    const ImageComponent = useMemo(() => ImageProp || Image, [ImageProp]);

    return (
        <div className={classes.root}>
            <div className={classes.canvas}>
                <div className={classes.logo}>{logo}</div>
                <Text type="h6" className={classes.title}>
                    {title}
                </Text>
                {description && (
                    <Text type="body" className={classes.description}>
                        {description}
                    </Text>
                )}
                <ImageComponent className={classes.image} />
            </div>
        </div>
    );
};

export default memo(Error);
